import { withParseAvailability, productIds } from '@eti/products';
import { hasAvailability } from '../../payment/entry-page/utils/ancillaryProducts';

export const transformCartProducts = (
  getTranslation,
  products,
  bounds = [],
  numberOfTravelers = 1,
) =>
  Array.isArray(products) && products.length
    ? products.map(
        ({
          id,
          name,
          productSummaryAlternativeName,
          totalPrice,
          productSpecificTexts,
          ...rest
        }) => {
          const productName = productIds[id];
          const parseAvailability = withParseAvailability(
            Number(id),
            getTranslation,
            `${productName?.toLowerCase()}GeneralPurpose`,
          );

          return {
            id,
            price: totalPrice,
            title: productSummaryAlternativeName || name,
            name: productName,
            availability: hasAvailability(productSpecificTexts)
              ? parseAvailability(
                  productSpecificTexts?.productSegmentAvailabilityTexts,
                  bounds,
                  numberOfTravelers,
                )
              : null,
            totalPrice,
            ...rest,
          };
        },
      )
    : [];
